module.exports = {"TXTCLI_Currency":{"id":"TXTCLI_Currency","defaultMessage":"Νόμισμα","track":"Currency"}}